import { SectionWrapper } from '@/components';
import styled from 'styled-components';
import { TrackingWidgetWrapper } from './components/ShipmentSearch/ShipmentSearch.styles';

export const ShipmentListSectionWrapper = styled(SectionWrapper)(({ theme }) => ({
  [`${theme.mediaBreakpointDown.md}`]: {
    borderTop: 0,
    marginBottom: '0 !important',
    backgroundColor: theme.colors.highEmphasisWhite,
    boxShadow: 'none',
  },
}));

export const ShipmentsOverviewWrapper = styled.div<{ noShipmentsAdded?: boolean }>(({ theme, noShipmentsAdded }) => ({
  backgroundColor: theme.colors.pageBackground,

  [`${theme.mediaBreakpointUp.lg}`]: {
    [`${ShipmentListSectionWrapper}`]: {
      padding: noShipmentsAdded ? theme.spacing[20] : 0,
    },
    [`${TrackingWidgetWrapper}`]: {
      padding: noShipmentsAdded ? 0 : theme.spacing[20],
    },
  },

  [`${theme.mediaBreakpointDown.md}`]: {
    padding: noShipmentsAdded ? theme.spacing[20] : 0,
    backgroundColor: noShipmentsAdded ? theme.colors.highEmphasisWhite : theme.colors.pageBackground,

    [`${ShipmentListSectionWrapper}`]: {
      padding: 0,
    },
    [`${TrackingWidgetWrapper}`]: {
      padding: noShipmentsAdded
        ? 0
        : `${theme.spacing[16]} ${theme.spacing[20]} ${theme.spacing[16]} ${theme.spacing[20]}`,
    },
  },
}));
